import React from "react";
import "styles/public.css";

const MainTitle = ({ children }) => {
  return <h1 className="main_title_header">{children}</h1>;
}; 

export default MainTitle;
